import { render } from "./SvgCircle.vue?vue&type=template&id=39a3d4ea&ts=true"
import script from "./SvgCircle.vue?vue&type=script&lang=ts"
export * from "./SvgCircle.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/tumeda/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__